module.exports = __webpack_public_path__ + "img/dgjg2250_2.ad6a3277.svg";